import React from "react";
import axios from "axios";

import { isSuperAdmin } from "../../../lib/util/AuthUtils";
import * as EnvironmentUtils from "../../../lib/util/EnvironmentUtils";

export default class UpdateIndicator extends React.Component {
	state = {
		serverApp: null,
	};

	componentDidMount() {
		if (isSuperAdmin()) {
			setInterval(() => {
				this.checkForUpdates();
			}, 1000 * 60 * 5);
			this.checkForUpdates();
		}
	}

	async checkForUpdates() {
		try {
			const response = await axios.get(`${window.location.origin}/_app.json`);
			this.setState({ serverApp: response.data });
		} catch (e) {
			console.error("Checking for updates failed...", e);
		}
	}

	handleReload = (e) => {
		e.preventDefault();
		window.location.reload(true);
	};

	render() {
		const { serverApp } = this.state;
		const app = EnvironmentUtils.getAppInfo();

		let needsUpdates = false;

		if (serverApp && serverApp.build && app.build) {
			const serverBuild = new Date(serverApp.build.started);
			const appBuild = new Date(app.build.started);
			if (serverBuild.valueOf() > appBuild.valueOf()) {
				needsUpdates = true;
			}
		}

		return isSuperAdmin() && needsUpdates ? (
			<button
				className={"UpdateIndicator --visible"}
				onClick={this.handleReload}
			>
				<a href={window.location.href}>
					Your version of the site is outdated, press here to reload.
				</a>
			</button>
		) : (
			<div className={"UpdateIndicator__stub"} />
		);
	}
}
